// extracted by mini-css-extract-plugin
export default {"tooltip":"oX-z","arrow":"pX-z"};